import { createContext } from 'react';

const ClientesContext = createContext();

export default ClientesContext;
